import { getLoginClientMetadata } from "./loginEvents";
import { graphqlUserPool } from "./graphqlUserPool";

type RecordLegalAcceptanceArgs = {
  userId: string;
  version: string;
  sessionId: string;
  authToken?: string;
};

const createLegalAcceptanceMutation = /* GraphQL */ `mutation CreateLegalAcceptance(
  $input: CreateLegalAcceptanceInput!
  $condition: ModelLegalAcceptanceConditionInput
) {
  createLegalAcceptance(input: $input, condition: $condition) {
    id
    version
    acceptedAt
    __typename
  }
}`;

// Reuses getLoginClientMetadata (loginEvents.ts) rather than duplicating UA-sniffing
// logic. This is a plain generated createLegalAcceptance mutation, no custom
// Lambda resolver — mirrors logSessionEvent's write pattern for LoginEvent, since
// this write needs no server-side logic (encryption, signing, limit enforcement).
export async function recordLegalAcceptance({
  userId,
  version,
  sessionId,
  authToken,
}: RecordLegalAcceptanceArgs): Promise<void> {
  const metadata = getLoginClientMetadata();

  await graphqlUserPool<unknown>({
    query: createLegalAcceptanceMutation,
    variables: {
      input: {
        userId,
        version,
        acceptedAt: new Date().toISOString(),
        sessionId,
        sourceApp: "web",
        clientType: metadata.clientType,
        browser: metadata.browser,
        os: metadata.os,
        userAgent: metadata.userAgent,
      },
    },
    authToken,
  });
}
